import {type ToastMessage} from 'primereact/toast';

export const NotificationMarkedAsReadMessage: ToastMessage = {
    severity: 'success',
    summary: 'Processed',
    detail: 'Notification successfully marked as read',
};
